<template>
  <div class="home">
    <template>
      <b-container class="container-rda" v-if="selected && !loadingSelected">
        <b-row>
          <b-col>
            <Breadcrumb :breadcrumb="breadcrumb" />
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <h2 class="purple bold">Validar matrícula</h2>
          </b-col>
        </b-row>
        <b-row class="mt-50">
          <b-col v-if="selected.EnrollmentStudent" md="4">
            <p class="bold">Aluno</p>
            <p v-if="selected.EnrollmentStudent">
              {{ selected.EnrollmentStudent.name }}
            </p>
            <p v-else>Matrícula incompleta</p>
          </b-col>
          <b-col v-if="selected.EnrollmentResponsibles" md="4">
            <p class="bold">Contratante responsável</p>
            <p v-if="selected.EnrollmentResponsibles">
              {{ selected.EnrollmentResponsibles[0].name }}
            </p>
            <p v-else>Matrícula incompleta</p>
          </b-col>
          <b-col v-if="selected.EnrollmentStudent.time_period" md="4">
            <p class="bold">Turno</p>
            <p>
              {{
                selected.EnrollmentStudent.time_period === "Matutino"
                  ? "Manhã"
                  : "Tarde"
              }}
            </p>
          </b-col>
        </b-row>
        <b-row class="mt-5">
          <b-col md="12">
            <b-row>
              <b-col md="12">
                <h3 class="purple mb-4">Ciclo e turma</h3>
              </b-col>
              <b-col md="6">
                <SelectCycles
                  placeholder="Selecione"
                  v-model="cycleIdSelect"
                  :callback="callbackCycles"
                >
                </SelectCycles>
              </b-col>
              <b-col md="6">
                <SelectClassrooms
                  placeholder="Selecione"
                  v-model="classroom.classroom_id"
                  :callback="callbackClassrooms"
                  :yearsback="1"
                  :cycle="cycleIdSelect"
                >
                </SelectClassrooms>
              </b-col>
              <b-col md="6" :class="{ 'required-highlight': isChangingClassroom }">
                <FrequencyInput
                  v-model="selected.EnrollmentStudent.starting_frequency"
                  type="text"
                  name="name"
                  v-mask="'##/##/####'"
                  label="Data de início da frequência"
                  :onChange="callbackStartingFrequency"
                  :description="isChangingClassroom && previousStartingFrequency ? `Última data de início da frequência: ${previousStartingFrequency}` : ''"
                >
                </FrequencyInput>
              </b-col>
              <b-col md="6">
                <p class="">Ano da matrícula</p>
                <multiselect
                  :value="selectedCalendar"
                  :options="calendars"
                  :multiple="false"
                  :close-on-select="true"
                  :clear-on-select="false"
                  :preserve-search="true"
                  label="name"
                  track-by="id"
                  selectLabel=""
                  placeholder="Selecione"
                  @select="handleCalendar"
                >
                  <span slot="noResult">Nada encontrado</span>
                </multiselect>
              </b-col>
            </b-row>
          </b-col>
        </b-row>

        <b-row class="mt-4">
          <b-col md="8">
            <b-row>
              <b-col md="12">
                <h3 class="purple mb-4">Movimentação</h3>
              </b-col>
              <b-col md="12" v-if="isFirstClassroom">
                <div class="first-classroom-info">
                  <b-icon icon="info-circle" class="first-classroom-info__icon"></b-icon>
                  <div>
                    <p class="first-classroom-info__title">
                      Primeira enturmação do aluno
                    </p>
                    <p class="first-classroom-info__text">
                      O aluno será enturmado em
                      <strong>{{ pendingClassroom ? pendingClassroom.designation : 'nova turma' }}</strong>.
                      <span v-if="!isMovementValid">
                        Preencha a <strong>Data de início da frequência</strong> acima para salvar.
                      </span>
                    </p>
                  </div>
                </div>
              </b-col>
              <b-col md="6" v-if="!isFirstClassroom">
                <p>Tipo de movimentação</p>
                <multiselect
                  v-model="exitType"
                  :options="exitTypeOptions"
                  :multiple="false"
                  :close-on-select="true"
                  :clear-on-select="false"
                  :preserve-search="true"
                  :disabled="isChangingClassroom"
                  label="text"
                  track-by="value"
                  selectLabel=""
                  placeholder="Selecione"
                >
                  <span slot="noResult">Nada encontrado</span>
                </multiselect>
              </b-col>
              <b-col md="6" v-if="isExitRequired" :class="{ 'required-highlight': isExitRequired }">
                <FrequencyInput
                  v-model="exitDate"
                  type="text"
                  name="exit_date"
                  v-mask="'##/##/####'"
                  :label="exitDateLabel"
                  placeholder="Selecione"
                >
                </FrequencyInput>
              </b-col>
            </b-row>

            <b-row class="mt-3" v-if="isExitRequired || isFirstClassroom">
              <b-col md="12" class="d-flex justify-content-between">
                <b-button
                  @click="resetMovementState"
                  variant="link"
                  class="px-4 py-2"
                  style="color: #fff"
                >
                  Cancelar
                </b-button>
                <b-button
                  :disabled="!isMovementValid"
                  @click="handleSaveMovement"
                  variant="primary"
                  class="px-4 py-2"
                >
                  Salvar alteração
                </b-button>
              </b-col>
            </b-row>
          </b-col>

          <b-col md="4">
            <h3 class="purple mb-4">Histórico de movimentações</h3>
            <div v-if="loadingHistory" class="text-center py-3">
              <b-spinner variant="success" label="Carregando..."></b-spinner>
            </div>
            <div class="history-timeline" v-else-if="history.length">
              <div
                class="history-item"
                v-for="(movement, index) in history"
                :key="index"
              >
                <div class="history-dot" :class="`dot-${movement.type}`"></div>
                <div class="history-content" :class="`border-${movement.type}`">
                  <span class="history-tag" :class="`tag-${movement.type}`">
                    {{ historyTypeLabel(movement.type) }}
                  </span>
                  <p>{{ movement.text }}</p>
                </div>
              </div>
            </div>
            <div class="history-empty" v-else>
              <p>Nenhuma movimentação registrada.</p>
            </div>
          </b-col>
        </b-row>

        <b-row class="mt-5" v-if="selected && selected.id">
          <b-col md="12">
            <h3 class="purple mb-4">Situação no ciclo</h3>
          </b-col>

          <b-row
            style="padding-top: 0 !important; margin-top: 0 !important"
            class="pt-5 mt-5 mb-4"
          >
            <b-col>
              <CycleSituation
                :key="cycleSituationKey"
                :studentId="+selected.id"
                :cycleId="+currentCycle"
              />
            </b-col>
          </b-row>
        </b-row>

        <b-row
          class="mt-5"
          v-if="selected.EnrollmentFile || this.rdaUnit == 'POUSO_ALEGRE'"
        >
          <b-col md="6">
            <h3 class="purple bold">Documentos do aluno:</h3>
          </b-col>
          <b-col>
            <h5 class="purple bold">Download do documento:</h5>
          </b-col>
          <b-col>
            <h5 class="purple bold">Validade do documento:</h5>
          </b-col>
        </b-row>
        <b-row v-else class="mt-5">
          <b-col>
            <h5>Matrícula incompleta ou em andamento</h5>
          </b-col>
        </b-row>
        <b-row
          class="mt-5 pb-5 list-downloads"
          v-if="
            (selected.EnrollmentFile &&
              rdaUnit != 'POUSO_ALEGRE' &&
              currentCycle != 8) ||
            rdaUnit == 'POUSO_ALEGRE'
          "
        >
          <b-col md="6">
            <h5 class="bold">Contrato</h5>

            <a
              v-if="selected.EnrollmentFile.is_valid_contract == false"
              class="btn-link pointer"
              @click="generateNewContract(selected.id)"
              >Gerar um novo contrato?</a
            >
            <b-button
              v-if="!selected.signed_at && !updatingStatus"
              class="pointer"
              style="margin-top: 15px; margin-bottom: -20px"
              @click="updateContractStatus(selected.id)"
            >
              Atualizar status do contrato</b-button
            >

            <b-row align="center" v-if="updatingStatus">
              <b-col class="mt-5">
                <b-spinner variant="success" label="Carregando..."></b-spinner>
              </b-col>
            </b-row>
          </b-col>

          <b-col>
            <b-button
              v-if="selected.EnrollmentFile.contract == null"
              class="large pending"
              >Pendente</b-button
            >
            <b-button
              v-else
              :href="selected.EnrollmentFile.contract"
              download
              target="_blank"
              class="large blue"
              >Download</b-button
            >
          </b-col>
          <b-col>
            <b-form-group class="group-radio">
              <div class="radio-inline">
                <b-form-radio
                  v-model="selected.EnrollmentFile.is_valid_contract"
                  id="is_valid_contract-1"
                  name="options-is_valid_contract"
                  value="true"
                  @change="validContract(selected.id, true)"
                  >Válido</b-form-radio
                >
                <b-form-radio
                  v-model="selected.EnrollmentFile.is_valid_contract"
                  id="is_valid_contract-2"
                  name="options-is_valid_contract"
                  value="false"
                  @change="validContract(selected.id, false)"
                  >Inválido</b-form-radio
                >
              </div>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row class="pt-5 pb-5 list-downloads" v-if="selected.EnrollmentFile">
          <b-col md="12" class="mb-5">
            <h5 class="bold">Carteira de Identidade</h5>
          </b-col>
          <b-col md="6" class="mb-5">
            <h5 class="bold">Frente</h5>
          </b-col>
          <b-col md="3" class="mb-5">
            <b-button
              v-if="selected.EnrollmentFile.identity == null"
              class="large pending"
              >Pendente</b-button
            >
            <b-button
              v-else
              :href="selected.EnrollmentFile.identity"
              download
              target="_blank"
              class="large blue"
              >Download</b-button
            >
          </b-col>
          <b-col md="3" class="mb-5">
            <b-form-group class="group-radio">
              <div class="radio-inline">
                <b-form-radio
                  v-model="selected.EnrollmentFile.is_valid_identity"
                  name="options-is_valid_identity"
                  id="is_valid_identity-1"
                  value="true"
                  @change="validIndentity(selected.id, true)"
                  >Válido</b-form-radio
                >
                <b-form-radio
                  v-model="selected.EnrollmentFile.is_valid_identity"
                  name="options-is_valid_identity"
                  id="is_valid_identity-2"
                  value="false"
                  @change="validIndentity(selected.id, false)"
                  >Inválido</b-form-radio
                >
              </div>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <h5 class="bold">Verso</h5>
          </b-col>
          <b-col md="3">
            <b-button
              v-if="selected.EnrollmentFile.identity_back == null"
              class="large pending"
              >Pendente</b-button
            >
            <b-button
              v-else
              :href="selected.EnrollmentFile.identity_back"
              download
              target="_blank"
              class="large blue"
              >Download</b-button
            >
          </b-col>
          <b-col md="3">
            <b-form-group class="group-radio">
              <div class="radio-inline">
                <b-form-radio
                  v-model="selected.EnrollmentFile.is_valid_identity_back"
                  name="options-is_valid_identity_back"
                  id="is_valid_identity_back-1"
                  value="true"
                  @change="validIndentityBack(selected.id, true)"
                  >Válido</b-form-radio
                >
                <b-form-radio
                  v-model="selected.EnrollmentFile.is_valid_identity_back"
                  name="options-is_valid_identity_back"
                  id="is_valid_identity_back-2"
                  value="false"
                  @change="validIndentityBack(selected.id, false)"
                  >Inválido</b-form-radio
                >
              </div>
            </b-form-group>
          </b-col>
        </b-row>

        <b-row class="pt-5 pb-5 list-downloads" v-if="selected.EnrollmentFile">
          <b-col md="6">
            <h5 class="bold">CPF</h5>
          </b-col>
          <b-col>
            <b-button
              v-if="selected.EnrollmentFile.cpf == null"
              class="large pending"
              >Pendente</b-button
            >
            <b-button
              v-else
              :href="selected.EnrollmentFile.cpf"
              download
              target="_blank"
              class="large blue"
              >Download</b-button
            >
          </b-col>
          <b-col>
            <b-form-group class="group-radio">
              <div class="radio-inline">
                <b-form-radio
                  v-model="selected.EnrollmentFile.is_valid_cpf"
                  name="options-is_valid_cpf"
                  id="is_valid_cpf-1"
                  value="true"
                  @change="validCPF(selected.id, true)"
                  >Válido</b-form-radio
                >
                <b-form-radio
                  v-model="selected.EnrollmentFile.is_valid_cpf"
                  name="options-is_valid_cpf"
                  id="is_valid_cpf-2"
                  value="false"
                  @change="validCPF(selected.id, false)"
                  >Inválido</b-form-radio
                >
              </div>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row class="pt-5 pb-5 list-downloads" v-if="selected.EnrollmentFile">
          <b-col md="6">
            <h5 class="bold">Cartão de vacinas</h5>
          </b-col>
          <b-col>
            <b-button
              v-if="selected.EnrollmentFile.vaccination_record == null"
              class="large pending"
              >Pendente</b-button
            >
            <b-button
              v-else
              :href="selected.EnrollmentFile.vaccination_record"
              download
              target="_blank"
              class="large blue"
              >Download</b-button
            >
          </b-col>
          <b-col>
            <b-form-group class="group-radio">
              <div class="radio-inline">
                <b-form-radio
                  v-model="selected.EnrollmentFile.is_valid_vaccination_record"
                  name="options-is_valid_vaccination_record"
                  id="is_valid_vaccination_record-1"
                  value="true"
                  @change="validVaccination(selected.id, true)"
                  >Válido</b-form-radio
                >
                <b-form-radio
                  v-model="selected.EnrollmentFile.is_valid_vaccination_record"
                  name="options-is_valid_vaccination_record"
                  id="is_valid_vaccination_record-2"
                  value="false"
                  @change="validVaccination(selected.id, false)"
                  >Inválido</b-form-radio
                >
              </div>
            </b-form-group>
          </b-col>
        </b-row>

        <b-row class="pt-5 pb-5 list-downloads" v-if="selected.EnrollmentFile">
          <b-col md="6">
            <h5 class="bold">Comprovante de Residência</h5>
          </b-col>
          <b-col>
            <b-button
              v-if="selected.EnrollmentFile.proof_of_residence == null"
              class="large pending"
              >Pendente</b-button
            >
            <b-button
              v-else
              :href="selected.EnrollmentFile.proof_of_residence"
              download
              target="_blank"
              class="large blue"
              >Download</b-button
            >
          </b-col>
          <b-col>
            <b-form-group class="group-radio">
              <div class="radio-inline">
                <b-form-radio
                  v-model="selected.EnrollmentFile.is_valid_proof_of_residence"
                  name="options-is_valid_proof_of_residence"
                  id="is_valid_proof_of_residence-1"
                  value="true"
                  @change="validProofOfResidence(selected.id, true)"
                  >Válido</b-form-radio
                >
                <b-form-radio
                  v-model="selected.EnrollmentFile.is_valid_proof_of_residence"
                  name="options-is_valid_proof_of_residence"
                  id="is_valid_proof_of_residence-2"
                  value="false"
                  @change="validProofOfResidence(selected.id, false)"
                  >Inválido</b-form-radio
                >
              </div>
            </b-form-group>
          </b-col>
        </b-row>

        <b-row class="pt-5 pb-5 list-downloads" v-if="selected.EnrollmentFile">
          <b-col md="6">
            <h5 class="bold">Declaração de transferência</h5>
          </b-col>
          <b-col>
            <b-button
              v-if="selected.EnrollmentFile.transference_declaration == null"
              class="large pending"
              >Pendente</b-button
            >
            <b-button
              v-else
              :href="selected.EnrollmentFile.transference_declaration"
              download
              target="_blank"
              class="large blue"
              >Download</b-button
            >
          </b-col>
          <b-col>
            <b-form-group class="group-radio">
              <div class="radio-inline">
                <b-form-radio
                  v-model="
                    selected.EnrollmentFile.is_valid_transference_declaration
                  "
                  name="options-is_valid_transference_declaration"
                  id="is_valid_transference_declaration-1"
                  value="true"
                  @change="validTransference(selected.id, true)"
                  >Válido</b-form-radio
                >
                <b-form-radio
                  v-model="
                    selected.EnrollmentFile.is_valid_transference_declaration
                  "
                  name="options-is_valid_transference_declaration"
                  id="is_valid_transference_declaration-2"
                  value="false"
                  @change="validTransference(selected.id, false)"
                  >Inválido</b-form-radio
                >
              </div>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row class="pt-5 pb-5 list-downloads" v-if="selected.EnrollmentFile">
          <b-col md="6">
            <h5 class="bold">
              Declaração de quitação emitida pela escola anterior
            </h5>
          </b-col>
          <b-col>
            <b-button
              v-if="selected.EnrollmentFile.discharge == null"
              class="large pending"
              >Pendente</b-button
            >
            <b-button
              v-else
              :href="selected.EnrollmentFile.discharge"
              download
              target="_blank"
              class="large blue"
              >Download</b-button
            >
          </b-col>
          <b-col>
            <b-form-group class="group-radio">
              <div class="radio-inline">
                <b-form-radio
                  v-model="selected.EnrollmentFile.is_valid_discharge"
                  name="options-is_valid_discharge"
                  id="is_valid_discharge-1"
                  value="true"
                  @change="validDischarge(selected.id, true)"
                  >Válido</b-form-radio
                >
                <b-form-radio
                  v-model="selected.EnrollmentFile.is_valid_discharge"
                  name="options-is_valid_discharge"
                  id="is_valid_discharge-2"
                  value="false"
                  @change="validDischarge(selected.id, false)"
                  >Inválido</b-form-radio
                >
              </div>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row class="pt-5 pb-5 list-downloads" v-if="selected.EnrollmentFile">
          <b-col md="6">
            <h5 class="bold">
              Histórico Escolar/ Registro de Percurso (Educação Infantil)
            </h5>
          </b-col>
          <b-col>
            <b-button
              v-if="selected.EnrollmentFile.school_record == null"
              class="large pending"
              >Pendente</b-button
            >
            <b-button
              v-else
              :href="selected.EnrollmentFile.school_record"
              download
              target="_blank"
              class="large blue"
              >Download</b-button
            >
          </b-col>
          <b-col>
            <b-form-group class="group-radio">
              <div class="radio-inline">
                <b-form-radio
                  v-model="selected.EnrollmentFile.is_valid_school_record"
                  name="options-is_valid_school_record"
                  id="is_valid_school_record-1"
                  value="true"
                  @change="validSchoolRecord(selected.id, true)"
                  >Válido</b-form-radio
                >
                <b-form-radio
                  v-model="selected.EnrollmentFile.is_valid_school_record"
                  name="options-is_valid_school_record"
                  id="is_valid_school_record-2"
                  value="false"
                  @change="validSchoolRecord(selected.id, false)"
                  >Inválido</b-form-radio
                >
              </div>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row class="mt-5" v-if="selected.EnrollmentFile">
          <b-col md="6">
            <h3 class="purple bold">Documentos dos contratantes:</h3>
          </b-col>
          <b-col>
            <h5 class="purple bold">Download do documento:</h5>
          </b-col>
          <b-col>
            <h5 class="purple bold">Validade do documento:</h5>
          </b-col>
        </b-row>
        <b-row class="pt-5 pb-5 list-downloads" v-if="selected.EnrollmentFile">
          <b-col md="12" class="mb-5">
            <h5>Carteira de Identidade dos contratantes</h5>
          </b-col>
          <b-col md="6" class="mb-5">
            <h5 class="bold">Contratante A</h5>
          </b-col>
          <b-col md="3" class="mb-5">
            <b-button
              v-if="selected.EnrollmentFile.identity_contractor_a == null"
              class="large pending"
              >Pendente</b-button
            >
            <b-button
              v-else
              :href="selected.EnrollmentFile.identity_contractor_a"
              download
              target="_blank"
              class="large blue"
              >Download</b-button
            >
          </b-col>
          <b-col md="3" class="mb-5">
            <b-form-group class="group-radio">
              <div class="radio-inline">
                <b-form-radio
                  v-model="
                    selected.EnrollmentFile.is_valid_identity_contractor_a
                  "
                  name="options-is_valid_identity_contractor_a"
                  id="is_valid_identity_contractor_a-1"
                  value="true"
                  @change="validIdentityContractorA(selected.id, true)"
                  >Válido</b-form-radio
                >
                <b-form-radio
                  v-model="
                    selected.EnrollmentFile.is_valid_identity_contractor_a
                  "
                  name="options-is_valid_identity_contractor_a"
                  id="is_valid_identity_contractor_a-2"
                  value="false"
                  @change="validIdentityContractorA(selected.id, false)"
                  >Inválido</b-form-radio
                >
              </div>
            </b-form-group>
          </b-col>
          <b-col md="6" class="mb-5">
            <h5 class="bold">Contratante A Verso</h5>
          </b-col>
          <b-col md="3" class="mb-5">
            <b-button
              v-if="selected.EnrollmentFile.identity_contractor_a_back == null"
              class="large pending"
              >Pendente</b-button
            >
            <b-button
              v-else
              :href="selected.EnrollmentFile.identity_contractor_a_back"
              download
              target="_blank"
              class="large blue"
              >Download</b-button
            >
          </b-col>
          <b-col md="3" class="mb-5">
            <b-form-group class="group-radio">
              <div class="radio-inline">
                <b-form-radio
                  v-model="
                    selected.EnrollmentFile.is_valid_identity_contractor_a_back
                  "
                  name="options-is_valid_identity_contractor_a_back"
                  id="is_valid_identity_contractor_a_back-1"
                  value="true"
                  @change="validIdentityContractorABack(selected.id, true)"
                  >Válido</b-form-radio
                >
                <b-form-radio
                  v-model="
                    selected.EnrollmentFile.is_valid_identity_contractor_a_back
                  "
                  name="options-is_valid_identity_contractor_a_back"
                  id="is_valid_identity_contractor_a_back-2"
                  value="false"
                  @change="validIdentityContractorABack(selected.id, false)"
                  >Inválido</b-form-radio
                >
              </div>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <h5 class="bold">Contratante B</h5>
          </b-col>
          <b-col md="3">
            <b-button
              v-if="selected.EnrollmentFile.identity_contractor_b == null"
              class="large pending"
              >Pendente</b-button
            >
            <b-button
              v-else
              :href="selected.EnrollmentFile.identity_contractor_b"
              download
              target="_blank"
              class="large blue"
              >Download</b-button
            >
          </b-col>
          <b-col md="3" class="mb-5">
            <b-form-group class="group-radio">
              <div class="radio-inline">
                <b-form-radio
                  v-model="
                    selected.EnrollmentFile.is_valid_identity_contractor_b
                  "
                  name="options-is_valid_identity_contractor_b"
                  id="is_valid_identity_contractor_b-1"
                  value="true"
                  @change="validIdentityContractorB(selected.id, true)"
                  >Válido</b-form-radio
                >
                <b-form-radio
                  v-model="
                    selected.EnrollmentFile.is_valid_identity_contractor_b
                  "
                  name="options-is_valid_identity_contractor_b"
                  id="is_valid_identity_contractor_b-2"
                  value="false"
                  @change="validIdentityContractorB(selected.id, false)"
                  >Inválido</b-form-radio
                >
              </div>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <h5 class="bold">Contratante B Verso</h5>
          </b-col>
          <b-col md="3">
            <b-button
              v-if="selected.EnrollmentFile.identity_contractor_b_back == null"
              class="large pending"
              >Pendente</b-button
            >
            <b-button
              v-else
              :href="selected.EnrollmentFile.identity_contractor_b_back"
              download
              target="_blank"
              class="large blue"
              >Download</b-button
            >
          </b-col>
          <b-col md="3">
            <b-form-group class="group-radio">
              <div class="radio-inline">
                <b-form-radio
                  v-model="
                    selected.EnrollmentFile.is_valid_identity_contractor_b_back
                  "
                  name="options-is_valid_identity_contractor_b_back"
                  id="is_valid_identity_contractor_b_back-1"
                  value="true"
                  @change="validIdentityContractorBBack(selected.id, true)"
                  >Válido</b-form-radio
                >
                <b-form-radio
                  v-model="
                    selected.EnrollmentFile.is_valid_identity_contractor_b_back
                  "
                  name="options-is_valid_identity_contractor_b_back"
                  id="is_valid_identity_contractor_b_back-2"
                  value="false"
                  @change="validIdentityContractorBBack(selected.id, false)"
                  >Inválido</b-form-radio
                >
              </div>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row class="pt-5 pb-5 list-downloads" v-if="selected.EnrollmentFile">
          <b-col md="12" class="mb-5">
            <h5>CPF dos contratantes</h5>
          </b-col>
          <b-col md="6" class="mb-5">
            <h5 class="bold">Contratante A</h5>
          </b-col>
          <b-col md="3" class="mb-5">
            <b-button
              v-if="selected.EnrollmentFile.cpf_contractor_a == null"
              class="large pending"
              >Pendente</b-button
            >
            <b-button
              v-else
              :href="selected.EnrollmentFile.cpf_contractor_a"
              download
              target="_blank"
              class="large blue"
              >Download</b-button
            >
          </b-col>
          <b-col md="3" class="mb-5">
            <b-form-group class="group-radio">
              <div class="radio-inline">
                <b-form-radio
                  v-model="selected.EnrollmentFile.is_valid_cpf_contractor_a"
                  name="options-is_valid_cpf_contractor_a"
                  id="is_valid_cpf_contractor_a-1"
                  value="true"
                  @change="validCPFContractorA(selected.id, true)"
                  >Válido</b-form-radio
                >
                <b-form-radio
                  v-model="selected.EnrollmentFile.is_valid_cpf_contractor_a"
                  name="options-is_valid_cpf_contractor_a"
                  id="is_valid_cpf_contractor_a-2"
                  value="false"
                  @change="validCPFContractorA(selected.id, false)"
                  >Inválido</b-form-radio
                >
              </div>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <h5 class="bold">Contratante B</h5>
          </b-col>
          <b-col md="3">
            <b-button
              v-if="selected.EnrollmentFile.cpf_contractor_b == null"
              class="large pending"
              >Pendente</b-button
            >
            <b-button
              v-else
              :href="selected.EnrollmentFile.cpf_contractor_b"
              download
              target="_blank"
              class="large blue"
              >Download</b-button
            >
          </b-col>
          <b-col md="3">
            <b-form-group class="group-radio">
              <div class="radio-inline">
                <b-form-radio
                  v-model="selected.EnrollmentFile.is_valid_cpf_contractor_b"
                  name="options-is_valid_cpf_contractor_b"
                  id="is_valid_cpf_contractor_b-1"
                  value="true"
                  @change="validCPFContractorB(selected.id, true)"
                  >Válido</b-form-radio
                >
                <b-form-radio
                  v-model="selected.EnrollmentFile.is_valid_cpf_contractor_b"
                  name="options-is_valid_cpf_contractor_b"
                  id="is_valid_cpf_contractor_b-2"
                  value="false"
                  @change="validCPFContractorB(selected.id, false)"
                  >Inválido</b-form-radio
                >
              </div>
            </b-form-group>
          </b-col>
        </b-row>
      </b-container>
    </template>
  </div>
</template>

<script>
import { mapActions } from "vuex";

import DataService from "@/services/enrollments.service";
import StudentService from "@/services/students.service";
import CycleSituation from "@/components/CycleSituation.vue";
import SelectCycles from "@/components/inputs/SelectCycles.vue";
import FrequencyInput from "@/components/inputs/FrequencyInput.vue";
import SelectClassrooms from "@/components/inputs/SelectClassrooms.vue";
import httpRda from "../../http-rda";
import moment from "moment";

export default {
  name: "validar-matricula",
  components: {
    SelectCycles,
    SelectClassrooms,
    FrequencyInput,
    CycleSituation,
  },
  data() {
    return {
      cycleSituationKey: 0,
      classroomModal: null,
      cycleDatesData: [],
      cycleIdSelect: null,
      currentCycle: null,
      originalClassroomId: null,
      originalClassroomDesignation: '',
      updatingStatus: false,
      exitType: null,
      exitDate: '',
      pendingClassroom: null,
      history: [],
      loadingHistory: false,
      loadingSelected: true,
      isChangingClassroom: false,
      previousStartingFrequency: '',
      calendars: [],
      selectedCalendar: null,
      classroom: {
        classroom_id: "",
      },
      rdaUnit: process.env.VUE_APP_RDA_UNIT,
      selected: {
        EnrollmentStudent: {
          cycle_id: "",
        },
        EnrollmentFile: {
          is_valid_contract: null,
        },
      },

      cicle: null,

      breadcrumb: [
        {
          text: "Secretaria",
          href: "/secretaria/contratos",
        },
        {
          text: "Pedidos",
          href: "/secretaria/pedidos",
        },
        {
          text: "Validar",
          href: "/validar-matricula",
          active: true,
        },
      ],
    };
  },

  computed: {
    hasClassroomChange() {
      return this.originalClassroomId && this.classroom.classroom_id && this.originalClassroomId !== this.classroom.classroom_id;
    },
    exitDateLabel() {
      if (this.isChangingClassroom) {
        return 'Data da saída';
      }

      const type = this.exitType ? this.exitType.value : null;

      if (type === 'conclusion') {
        return 'Data da conclusão';
      }

      if (type === 'transfer') {
        return 'Data da transferência';
      }

      return 'Data da saída';
    },
    isFirstClassroom() {
      return this.isChangingClassroom && !this.originalClassroomId;
    },
    isMovementValid() {
      if (this.isFirstClassroom) {
        return !!(this.selected.EnrollmentStudent && this.selected.EnrollmentStudent.starting_frequency);
      }

      if (!this.exitType) {
        return false;
      }

      if (this.isChangingClassroom) {
        return !!(this.exitDate && this.selected.EnrollmentStudent && this.selected.EnrollmentStudent.starting_frequency);
      }

      return !!this.exitDate;
    },
    isExitRequired() {
      return !!this.exitType;
    },
    exitTypeOptions() {
      if (this.isChangingClassroom) {
        const name = this.originalClassroomDesignation || '';
        return [{ value: 'exit', text: `Saída da turma ${name}` }];
      }
      return [
        { value: 'conclusion', text: 'Conclusão' },
        { value: 'transfer', text: 'Transferência' },
      ];
    },
  },

  filters: {
    date(date) {
      try {
        var d = new Date(date.split());
        var year = d.getFullYear().toString();
        var month = (d.getMonth() + 1).toString().padStart(2, "0");
        var day = d.getUTCDate().toString().padStart(2, "0");

        return day + "/" + month + "/" + year;
      } catch (error) {
        return date;
      }
    },
  },

  methods: {
    ...mapActions({
      requestContract: "enrollment/requestContractOnClickSign",
    }),

    historyTypeLabel(type) {
      const labels = {
        join: 'Entrada',
        exit: 'Saída',
        transfer: 'Transferência',
        conclusion: 'Conclusão',
      };
      return labels[type] || type;
    },

    async handleCalendar(calendar) {
      if (calendar.id && calendar.name) {
        this.$swal
          .fire({
            title: `Deseja alterar o ano da matrícula do aluno(a) para ${calendar.name}?`,
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#68c5b7",
            cancelButtonColor: "#d33",
            confirmButtonText: "Sim",
            cancelButtonText: "Cancelar",
          })
          .then(async (result) => {
            if (result.isConfirmed) {
              await httpRda
                .patch(`/enrollments/${this.selected.id}`, {
                  calendar_id: calendar.id,
                })
                .then(() => {
                  this.selectedCalendar = calendar;
                  const Toast = this.$swal.mixin({
                    toast: true,
                    position: "bottom-end",
                    showConfirmButton: false,
                    timer: 5000,
                    timerProgressBar: true,
                    didOpen: (toast) => {
                      toast.addEventListener(
                        "mouseenter",
                        this.$swal.stopTimer
                      );
                      toast.addEventListener(
                        "mouseleave",
                        this.$swal.resumeTimer
                      );
                    },
                  });

                  Toast.fire({
                    icon: "success",
                    title: `Ano atualizado com sucesso!`,
                  });
                })
                .catch(() => {
                  this.$swal.fire({
                    icon: "error",
                    title: "Oops...",
                    text: "Não foi possivel atualizar!",
                    footer: "Por favor, tente novamente mais tarde.",
                  });
                });
            }
          })
          .catch(() => {
            this.$swal.fire({
              icon: "error",
              title: "ok",
              text: "Ação não realizada!",
              footer: "Por favor, tente novamente mais tarde.",
            });
          });
      }
    },

    async getCalendars() {
      try {
        const response = await httpRda.get("/calendars");
        this.calendars = (response.data.calendars || []).map((calendar) => ({
          id: calendar.id,
          name: calendar.designation,
        }));
        this.calendars = [...this.calendars, { id: null, name: null }];
      } catch {
        this.calendars = [];
      }
    },

    getSelected(id) {
      this.loadingSelected = true;

      DataService.getForValidation(id)
        .then((response) => {
          this.selected = response.data.enrollment;
          this.currentCycle =
            this.selected &&
            this.selected.EnrollmentStudent &&
            this.selected.EnrollmentStudent.cycle_id;
          this.cycleIdSelect = this.currentCycle;
          this.calendars.find((calendar) => {
            if (calendar.id == this.selected.calendar_id) {
              this.selectedCalendar = calendar;
            }
          });

          StudentService.get(id)
            .then((response) => {
              this.classroom = response.data.student;
              this.originalClassroomId = this.classroom.classroom_id;
              this.originalClassroomDesignation = (this.classroom.Classroom && this.classroom.Classroom.designation) || '';
              if (this.classroom.Cycle && this.classroom.Cycle.id) {
                this.cycleIdSelect = this.classroom.Cycle.id;
                this.currentCycle = this.classroom.Cycle.id;
              }

              this.loadingSelected = false;
            })
            .catch(() => {
              this.loadingSelected = false;
              this.$swal.fire({
                icon: "error",
                title: "Oops...",
                text: "Não foi possivel carregar a turma!",
                footer: "Por favor, tente novamente mais tarde.",
              });
            });
        })
        .catch(() => {
          this.loadingSelected = false;
          this.$swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Não foi possivel carregar a matrícula!",
            footer: "Por favor, tente novamente mais tarde.",
          });
        });
    },

    validContract(id, status) {
      var data = {
        is_valid_contract: status,
      };
      this.updateStatusFile(id, data);
    },

    validIndentity(id, status) {
      var data = {
        is_valid_identity: status,
      };
      this.updateStatusFile(id, data);
    },

    validIndentityBack(id, status) {
      var data = {
        is_valid_identity_back: status,
      };
      this.updateStatusFile(id, data);
    },

    validCPF(id, status) {
      var data = {
        is_valid_cpf: status,
      };
      this.updateStatusFile(id, data);
    },

    validVaccination(id, status) {
      var data = {
        is_valid_vaccination_record: status,
      };
      this.updateStatusFile(id, data);
    },

    validProofOfResidence(id, status) {
      var data = {
        is_valid_proof_of_residence: status,
      };
      this.updateStatusFile(id, data);
    },

    validTransference(id, status) {
      var data = {
        is_valid_transference_declaration: status,
      };
      this.updateStatusFile(id, data);
    },

    validDischarge(id, status) {
      var data = {
        is_valid_discharge: status,
      };
      this.updateStatusFile(id, data);
    },

    validSchoolRecord(id, status) {
      var data = {
        is_valid_school_record: status,
      };
      this.updateStatusFile(id, data);
    },

    validIdentityContractorA(id, status) {
      var data = {
        is_valid_identity_contractor_a: status,
      };
      this.updateStatusFile(id, data);
    },

    validIdentityContractorABack(id, status) {
      var data = {
        is_valid_identity_contractor_a_back: status,
      };
      this.updateStatusFile(id, data);
    },

    validIdentityContractorB(id, status) {
      var data = {
        is_valid_identity_contractor_b: status,
      };
      this.updateStatusFile(id, data);
    },

    validIdentityContractorBBack(id, status) {
      var data = {
        is_valid_identity_contractor_b_back: status,
      };
      this.updateStatusFile(id, data);
    },

    validCPFContractorA(id, status) {
      var data = {
        is_valid_cpf_contractor_a: status,
      };
      this.updateStatusFile(id, data);
    },

    validCPFContractorB(id, status) {
      var data = {
        is_valid_cpf_contractor_b: status,
      };
      this.updateStatusFile(id, data);
    },

    updateStatusFile(id, data) {
      DataService.postFile(id, data)
        .then((response) => {
          this.getSelected(id);
          this.toastSucess();

          return response.data;
        })
        .catch((error) => {
          this.toastError();
          return error.response;
        });
    },

    toastSucess() {
      const Toast = this.$swal.mixin({
        toast: true,
        position: "bottom-end",
        showConfirmButton: false,
        timer: 5000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", this.$swal.stopTimer);
          toast.addEventListener("mouseleave", this.$swal.resumeTimer);
        },
      });
      Toast.fire({
        icon: "success",
        title: "Status atualizado!",
      });
    },

    toastError() {
      this.$swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Não foi possivel atualizar!",
        footer: "Por favor, tente novamente mais tarde.",
      });
    },

    validateExitDate(date){
      return moment(date, 'DD/MM/YYYY', true).isValid()
    },

    callbackStartingFrequency(args) {
      if (this.isChangingClassroom || !args?.target?.value) {
        return;
      }

      this.$swal
        .fire({
          title: "Deseja alterar a data de frequência inicial atual?",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#68c5b7",
          cancelButtonColor: "#d33",
          confirmButtonText: "Sim",
          cancelButtonText: "Cancelar",
        })
        .then(async (result) => {
          if (result.isConfirmed) {
            try {
              const data = {
                starting_frequency: args.target.value,
                exit_type: "starting_frequency",
              };

              if(!data.starting_frequency || !this.validateExitDate(data.starting_frequency)) {
                throw new Error("Insira uma data válida para a frequência inicial.");
              }

              await DataService.updateEnrollmentStudent(
                this.$route.params.id,
                data
              );
              this.$swal
                .fire("Sucesso!", "O Estudante foi atualizado.", "success")
                .then(async (response) => {
                  await this.getHistory();await this.getHistory();
                  this.getSelected(this.$route.params.id);
                  return response.data;
                });
            } catch (error) {
              this.getSelected(this.$route.params.id);
              this.$swal.fire({
                icon: "error",
                title: "Oops...",
                text: error.message,
                footer: "Por favor, tente novamente mais tarde.",
              });

              return error.response;
            }
          }
        })
        .catch((error) => {
          this.getSelected(this.$route.params.id);
          this.$swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Não foi possivel atualizar!",
            footer: "Por favor, tente novamente mais tarde.",
          });
          return error.response;
        });
    },

    callbackCycles(args) {
      this.selected.EnrollmentStudent.cycle_id = args.id;

      this.$swal
        .fire({
          title: "Deseja alterar o Ciclo?",
          text: "A Matricula terá seu Ciclo atualizado.",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#68c5b7",
          cancelButtonColor: "#d33",
          confirmButtonText: "Sim",
          cancelButtonText: "Cancelar",
        })
        .then(async (result) => {
          if (result.isConfirmed) {
            try {
              const data = {
                cycle_id: args.id,
              };

              await DataService.updateCycle(this.$route.params.id, data);

              await StudentService.updateCycle(this.$route.params.id, data);

              this.$swal
                .fire("Sucesso!", "O Ciclo foi alterado.", "success")
                .then((response) => {
                  this.getSelected(this.$route.params.id);
                  return response.data;
                });
            } catch (error) {
              this.getSelected(this.$route.params.id);
              this.$swal.fire({
                icon: "error",
                title: "Oops...",
                text: "Não foi possivel alterar!",
                footer: "Por favor, tente novamente mais tarde.",
              });

              return error.response;
            }
          }
        })
        .catch((error) => {
          this.getSelected(this.$route.params.id);
          this.$swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Não foi possivel alterar!",
            footer: "Por favor, tente novamente mais tarde.",
          });
          return error.response;
        });
    },

    async callbackClassrooms(args) {
      const selectedClassroom = await this.getClassroomInfo(args.id);
      this.classroomModal = selectedClassroom;
      const hasClassroomChange = this.originalClassroomId !== args.id;
      this.classroom.classroom_id = args.id;

      if (hasClassroomChange) {
        this.previousStartingFrequency = this.selected.EnrollmentStudent && this.selected.EnrollmentStudent.starting_frequency
          ? this.selected.EnrollmentStudent.starting_frequency
          : '';
        this.pendingClassroom = selectedClassroom;
        this.isChangingClassroom = true;
        if (this.originalClassroomId) {
          this.exitType = this.exitTypeOptions[0];
        }
        this.selected.EnrollmentStudent.starting_frequency = '';
      } else {
        this.resetMovementState();
      }
    },

    async getClassroomInfo(classroomId) {
      const response = await httpRda.get(`/classrooms/${classroomId}`);
      return response.data.classroom || {};
    },

    async showCycleDatesModal(cycleId) {
      const { value: formValues } = await this.$swal.fire({
        title: "Dados do Ciclo",
        html: `
      <div style="text-align: left;">
        <label for="began-at" style="display: block; margin-bottom: 5px; font-weight: bold;">Data de início no ciclo:</label>
        <input id="began-at" type="date" class="swal2-input" style="margin-bottom: 15px;" value="${
          moment(this.classroomModal.began_at)
            .utcOffset(0)
            .format("YYYY-MM-DD") || ""
        }">

        <label for="target-date" style="display: block; margin-bottom: 5px; font-weight: bold;">Expectativa de término do ciclo:</label>
        <input id="target-date" type="date" class="swal2-input" value="${
          moment(this.classroomModal.finished_at)
            .utcOffset(0)
            .format("YYYY-MM-DD") || ""
        }">
      </div>
    `,
        focusConfirm: false,
        showCancelButton: true,
        confirmButtonColor: "#68c5b7",
        cancelButtonColor: "#d33",
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
        preConfirm: () => {
          const beganAt = document.getElementById("began-at").value;
          const targetDate = document.getElementById("target-date").value;

          if (!beganAt || !targetDate) {
            this.$swal.showValidationMessage(
              "Por favor, preencha ambas as datas"
            );
            return false;
          }

          if (new Date(beganAt) >= new Date(targetDate)) {
            this.$swal.showValidationMessage(
              "A data de início deve ser anterior à data de término"
            );
            return false;
          }

          return {
            situation: "regular",
            beganAt: beganAt,
            targetDate: targetDate,
            cycleId: cycleId,
          };
        },
      });

      if (!formValues) {
        this.getSelected(this.$route.params.id);
        return false;
      }

      this.cycleDatesData = formValues;
      return true;
    },

    async saveCycleDates() {
      try {
        const cyclesPayload = {
          cycles: [
            {
              cycleId: this.cycleDatesData.cycleId,
              situation: this.cycleDatesData.situation,
              target_date: this.cycleDatesData.targetDate,
              began_at: this.cycleDatesData.beganAt,
              finished_at: null,
              subjects: [],
            },
          ],
        };

        await httpRda.post(
          `/cycle-situations/${this.$route.params.id}`,
          cyclesPayload
        );

        this.cycleDatesData = null;
      } catch (error) {
        this.cycleDatesData = null;
        throw error;
      }
    },

    generateNewContract(id) {
      this.$swal
        .fire({
          title: "Deseja gerar um novo Contrato?",
          text: "Os Contratantes serão receberam por email um novo contrato.",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#68c5b7",
          cancelButtonColor: "#d33",
          confirmButtonText: "Sim",
          cancelButtonText: "Cancelar",
        })
        .then(async (result) => {
          if (result.isConfirmed) {
            try {
              this.requestContract({ id: id });
              this.$swal
                .fire(
                  "Sucesso!",
                  "Contrato enviado por e-mail para ser assinado.",
                  "success"
                )
                .then((response) => {
                  this.getSelected(this.$route.params.id);
                  return response.data;
                });
            } catch (error) {
              this.getSelected(this.$route.params.id);
              this.$swal.fire({
                icon: "error",
                title: "Oops...",
                text: "Não foi possivel gerar um novo contrato!",
                footer: "Por favor, tente novamente mais tarde.",
              });

              return error.response;
            }
          }
        })
        .catch((error) => {
          this.getSelected(this.$route.params.id);
          this.$swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Não foi possivel gerar um novo contrato!",
            footer: "Por favor, tente novamente mais tarde.",
          });

          return error.response;
        });
    },

    updateContractStatus(id) {
      this.$swal
        .fire({
          title: "Deseja atualizar o status do Contrato?",
          text: "Se o contrato já tiver sido assinado, o link do PDF será atualizado e o status do documento será alterado para 'VÁLIDO'.",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#68c5b7",
          cancelButtonColor: "#d33",
          confirmButtonText: "Sim",
          cancelButtonText: "Cancelar",
        })
        .then(async (result) => {
          if (result.isConfirmed) {
            this.updatingStatus = true;
            try {
              await httpRda
                .get(`/enrollments/${id}/update-contract-status?type=Webhook`)
                .then((resp) => {
                  if (resp.data.code === 202) {
                    this.$swal
                      .fire("o contrato ainda não assinado")
                      .then(async (response) => {
                        this.getSelected(this.$route.params.id);
                        this.updatingStatus = false;
                        return response.data;
                      });
                  } else if (resp.data.code === 204) {
                    this.$swal
                      .fire("O contrato foi cancelado ou finalizado")
                      .then(async (response) => {
                        this.getSelected(this.$route.params.id);
                        this.updatingStatus = false;
                        return response.data;
                      });
                  } else {
                    this.$swal
                      .fire("Contrato atualizado")
                      .then(async (response) => {
                        this.validContract(id, true);
                        this.getSelected(this.$route.params.id);
                        this.updatingStatus = false;
                        return response.data;
                      });
                  }
                });
            } catch (error) {
              this.getSelected(this.$route.params.id);
              this.updatingStatus = false;
              this.$swal.fire({
                icon: "error",
                title: "Oops...",
                text: error.response.data.message,
                footer: "Por favor, tente novamente mais tarde",
              });

              return error.response;
            }
          }
        })
        .catch((error) => {
          this.getSelected(this.$route.params.id);
          this.updatingStatus = false;
          this.$swal.fire({
            icon: "error",
            title: "Oops...",
            text: error.response.data.message,
            footer: "Por favor, tente novamente mais tarde.",
          });

          return error.response;
        });
    },

    async handleSaveMovement() {
      const confirmed = await this.showConfirmationModal();

      if (!confirmed) {
        return;
      }

      if (this.isChangingClassroom) {
        await this.saveClassroomChange();
      } else {
        await this.saveExitOnly();
      }

      await this.getHistory();
    },

    showConfirmationModal() {
      if (this.isFirstClassroom) {
        if (!this.validateExitDate(this.selected.EnrollmentStudent.starting_frequency)) {
          this.$swal.fire({
            icon: 'error',
            title: 'Oops...',
            text: 'Data de início de frequência da turma inválida!',
            footer: 'Por favor, insira uma data válida.',
          });

          return Promise.resolve(false);
        }

        return this.$swal.fire({
          title: 'Confirmar enturmação',
          html: `
            <div style="text-align: left;">
              <p><strong>Turma</strong><br>${this.pendingClassroom ? this.pendingClassroom.designation : '---'}</p>
              <p><strong>Início da frequência</strong><br>${this.selected.EnrollmentStudent.starting_frequency}</p>
              <p>Deseja continuar?</p>
            </div>
          `,
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#68c5b7',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Confirmar',
          cancelButtonText: 'Cancelar',
        }).then(result => result.isConfirmed);
      }

      if (this.isChangingClassroom) {
        if(!this.validateExitDate(this.exitDate)) {
          this.$swal.fire({
            icon: 'error',
            title: 'Oops...',
            text: 'Data de saída inválida!',
            footer: 'Por favor, insira uma data válida.',
          });

          return Promise.resolve(false);
        }

        if(!this.validateExitDate(this.selected.EnrollmentStudent.starting_frequency)) {
          this.$swal.fire({
            icon: 'error',
            title: 'Oops...',
            text: 'Data de início  de frequência da nova turma inválida!',
            footer: 'Por favor, insira uma data válida.',
          });

          return Promise.resolve(false);
        }

        return this.$swal.fire({
          title: 'Confirmar alteração',
          html: `
            <div style="text-align: left;">
              <p><strong>Turma anterior</strong><br>${this.originalClassroomDesignation || '---'}</p>
              <p><strong>Nova turma</strong><br>${this.pendingClassroom ? this.pendingClassroom.designation : '---'}</p>
              <p><strong>Saída da turma</strong><br>${this.exitDate || '---'}</p>
              <p><strong>Início na nova turma</strong><br>${this.selected.EnrollmentStudent ? this.selected.EnrollmentStudent.starting_frequency : '---'}</p>
              <p>Deseja continuar?</p>
            </div>
          `,
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#68c5b7',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Confirmar',
          cancelButtonText: 'Cancelar',
        }).then(result => result.isConfirmed);
      }

      const exitTypeLabel = this.exitType && this.exitType.value === 'conclusion' ? 'Conclusão' : 'Transferência';

      return this.$swal.fire({
        title: 'Confirmar',
        html: `
          <div style="text-align: left;">
            <p><strong>Tipo</strong><br>${exitTypeLabel}</p>
            <p><strong>Data</strong><br>${this.exitDate}</p>
          </div>
        `,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#68c5b7',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Confirmar',
        cancelButtonText: 'Cancelar',
      }).then(result => result.isConfirmed);
    },

    async saveClassroomChange() {
      try {
        const newCycle = this.pendingClassroom ? this.pendingClassroom.cycle_id : null;

        const classroomPayload = {
          classroom_id: this.classroom.classroom_id,
          exit_type: 'join',
        };

        if (!this.isFirstClassroom) {
          classroomPayload.exit_date = this.exitDate;
        }

        if (this.selected.EnrollmentStudent && this.selected.EnrollmentStudent.starting_frequency) {
          classroomPayload.starting_frequency = this.selected.EnrollmentStudent.starting_frequency;
        }

        const cycleDatesConfirmed = await this.showCycleDatesModal(newCycle);

        if (cycleDatesConfirmed) {
          await StudentService.update(this.$route.params.id, classroomPayload);
          await this.saveCycleDates();
        }

        this.$swal.fire('Sucesso!', 'O Aluno foi enturmado.', 'success')
          .then(() => {
            this.getSelected(this.$route.params.id);
            this.cycleSituationKey++;
            this.resetMovementState();
          });
      } catch (error) {
        this.getSelected(this.$route.params.id);
        this.$swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: 'Não foi possível alterar!',
          footer: 'Por favor, tente novamente mais tarde.',
        });
        this.resetMovementState();
      }
    },

    async saveExitOnly() {
      try {
        await StudentService.update(this.$route.params.id, {
          exit_type: this.exitType.value,
          exit_date: this.exitDate,
        });

        this.$swal.fire('Sucesso!', 'Saída registrada.', 'success')
          .then(() => {
            this.getSelected(this.$route.params.id);
            this.resetMovementState();
          });
      } catch (error) {
        this.getSelected(this.$route.params.id);
        this.$swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: 'Não foi possível salvar!',
          footer: 'Por favor, tente novamente mais tarde.',
        });
        this.resetMovementState();
      }
    },

    async getHistory() {
      this.loadingHistory = true;
      try {
        const response = await httpRda.get(`/students/${this.$route.params.id}/classrooms-history`);
        this.history = response.data.result || [];
      } catch {
        this.history = [];
      } finally {
        this.loadingHistory = false;
      }
    },

    resetMovementState() {
      location.reload();
    },

    setTodayDate() {
      this.exitDate = moment().format('DD/MM/YYYY');
    },
  },

  watch: {
    exitType(val) {
      if (val) {
        this.setTodayDate();
      }
    },
  },

  created() {
    this.getCalendars();
    this.getSelected(this.$route.params.id);
    this.getHistory();
  },
};
</script>

<style lang="scss">
@import "@/assets/css/variables.scss";

.required-highlight {
  .form-group {
    .form-control {
      border-color: $purple !important;
      animation: pulse-highlight 2s ease-in-out infinite;
      box-shadow: 0 0 0 0 rgba($purple, 0.4);
    }
  }
}

@keyframes pulse-highlight {
  0%, 100% {
    box-shadow: 0 0 0 0 rgba($purple, 0.4);
  }
  50% {
    box-shadow: 0 0 0 6px rgba($purple, 0);
  }
}

.first-classroom-info {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 14px 16px;
  border: 1px solid rgba($purple, 0.3);
  border-left: 4px solid $purple;
  border-radius: 6px;
  background: rgba($purple, 0.05);

  &__icon {
    flex-shrink: 0;
    margin-top: 3px;
    font-size: 18px;
    color: $purple;
  }

  &__title {
    margin: 0 0 4px;
    font-weight: bold;
    color: $purple;
  }

  &__text {
    margin: 0;
    font-size: 14px;
  }
}

.history-timeline {
  max-height: 260px;
  overflow-y: auto;
  padding: 4px 12px 4px 4px;

  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background: $green;
    border-radius: 10px;
  }
}

.history-item {
  position: relative;
  display: flex;
  align-items: flex-start;
  padding-left: 24px;
  padding-bottom: 10px;

  &:last-child {
    padding-bottom: 0;

    &::before {
      display: none;
    }
  }

  &::before {
    content: "";
    position: absolute;
    left: 5px;
    top: 16px;
    bottom: -4px;
    width: 2px;
    background: linear-gradient(to bottom, $green, rgba($green, 0.15));
  }
}

.history-dot {
  position: absolute;
  left: 0;
  top: 4px;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  box-shadow: 0 0 0 3px rgba(0, 0, 0, 0.08);

  &.dot-join {
    background: $green;
    box-shadow: 0 0 0 3px rgba($green, 0.2);
  }

  &.dot-exit {
    background: #e57373;
    box-shadow: 0 0 0 3px rgba(#e57373, 0.2);
  }

  &.dot-transfer {
    background: #4a90d9;
    box-shadow: 0 0 0 3px rgba(#4a90d9, 0.2);
  }

  &.dot-conclusion {
    background: $purple;
    box-shadow: 0 0 0 3px rgba($purple, 0.2);
  }
}

.history-content {
  background: #fff;
  border-radius: 12px;
  padding: 10px 14px;
  width: 100%;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);
  border: 1px solid $grey5;
  border-left: 3px solid transparent;

  &.border-join { border-left-color: $green; }
  &.border-exit { border-left-color: #e57373; }
  &.border-transfer { border-left-color: #4a90d9; }
  &.border-conclusion { border-left-color: $purple; }

  p {
    margin: 4px 0 0;
    font-size: 14px;
    color: $purple;
  }
}

.history-tag {
  display: inline-block;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  padding: 2px 8px;
  border-radius: 20px;

  &.tag-join {
    color: $green;
    background: rgba($green, 0.12);
  }

  &.tag-exit {
    color: #e57373;
    background: rgba(#e57373, 0.12);
  }

  &.tag-transfer {
    color: #4a90d9;
    background: rgba(#4a90d9, 0.12);
  }

  &.tag-conclusion {
    color: $purple;
    background: rgba($purple, 0.12);
  }
}

.history-empty {
  background: #fff;
  border: 1px dashed $grey5;
  border-radius: 12px;
  padding: 20px;
  text-align: center;

  p {
    margin: 0;
    color: $grey5;
  }
}

.list-downloads {
  position: relative;

  &::after {
    content: "";
    display: block;
    position: absolute;
    border-bottom: 1px solid $grey5;
    width: calc(100% - 30px);
    bottom: 0;
    left: 15px;
  }
}
</style>
